/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForCostAnomalyDetectorGraphDBSync extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForCostAnomalyDetectorGraphDBSync");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForCostAnomalyDetectorGraphDBSync.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForCostAnomalyDetectorGraphDBSync>): BackgroundJobPayloadForCostAnomalyDetectorGraphDBSync {
        let obj = Object.assign(new BackgroundJobPayloadForCostAnomalyDetectorGraphDBSync(), model);
        BackgroundJobPayloadForCostAnomalyDetectorGraphDBSync.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForCostAnomalyDetectorGraphDBSync>): BackgroundJobPayloadForCostAnomalyDetectorGraphDBSync {
        if (!model) return null;
        return BackgroundJobPayloadForCostAnomalyDetectorGraphDBSync.newInstance(<BackgroundJobPayloadForCostAnomalyDetectorGraphDBSync> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForCostAnomalyDetectorGraphDBSync) {
        if (!obj) return;

        models.BackgroundJobPayloadForCostAnomalyDetectorGraphDBSync.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForCostAnomalyDetectorGraphDBSync): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForCostAnomalyDetectorGraphDBSync.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Service Account whose cost-anomaly data is synced to GraphDB
     */
    service_account_id: string;

}
